export const REQUEST_ERROR_EVENT = 'skiloope:request-error';

// Never log request objects: Axios errors can contain authorization headers,
// personal data, and signed attachment URLs. Keep only diagnostic metadata.
export function reportError(error: unknown, context: string, notify = false): void {
  const response = (error as { response?: { status?: unknown } } | null)?.response;
  const status = typeof response?.status === 'number' ? response.status : undefined;
  if (process.env.NODE_ENV !== 'test') {
    console.error(`[${context}] Request failed`, { status });
  }
  if (notify) window.dispatchEvent(new Event(REQUEST_ERROR_EVENT));
}
